/**
 * Transient "this navigation came from the quick-search palette" intent.
 *
 * Lives as a module-level boolean — intentionally NOT sessionStorage,
 * which would survive a page refresh and cause `/?projectId=X` reloads
 * to re-collapse the user's tree (task #250). A module variable is
 * scoped to the current JS realm and dies on reload, which is exactly
 * the lifetime we want.
 *
 * Set by `QuickSearchDialog.handleSelect` right before it navigates.
 * Consumed (read-and-cleared atomically) by the dashboard's
 * `?projectId=…` mount effect to decide whether to call
 * `collapseAllExceptYears()` in addition to the focus dispatch.
 */

let fromSearch = false;

export function setFromSearchIntent() {
  fromSearch = true;
}

export function consumeFromSearchIntent(): boolean {
  const wasSet = fromSearch;
  fromSearch = false;
  return wasSet;
}
